/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { Tooltip } from 'bootstrap'

import { disposeTooltip } from '@/js/utils/bootstrap'
import { closest } from '@/js/utils/css'
import { findOne } from '@/js/utils/dom'

/**
 * Activate a Bootstrap tooltip on each tooltip-toggle element. Disposes it on
 * disconnect so the Turbo cache snapshot doesn't capture an open tooltip and
 * the underlying Bootstrap instance is released.
 *
 * @type {Listener}
 */
export default {
    selector: '[data-bs-toggle="tooltip"],[data-bs-tooltip="tooltip"]',
    connect(element) {
        const formGroup = closest(element, '.form-group')
        if (formGroup && findOne('label', formGroup)) {
            return
        }

        Tooltip.getOrCreateInstance(element, {
            html: true,
            boundary: 'window',
            container: '#content',
            delay: { show: 0, hide: 0 },
        })

        return () => disposeTooltip(Tooltip.getInstance(element))
    },
}
